import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getSession } from '../selectors';
import AppLandingPage from './AppLandingPage';
import AppSession from './AppSession';

class AppWrapper extends React.Component {
  static propTypes = {
    sessionId: PropTypes.string.isRequired,
    sessionKey: PropTypes.string.isRequired,
    session: PropTypes.object,
  }

  static defaultProps = {
    session: null,
  }

  render() {
    if (this.props.session) {
      return (
        <AppSession />
      );
    }
    return (
      <AppLandingPage
        appId={this.props.appId}
        accessKey={this.props.accessKey}
        sessionId={this.props.sessionId}
        sessionKey={this.props.sessionKey}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const session = getSession(state);
  return {
    session,
  };
};

export default connect(mapStateToProps)(AppWrapper);
